import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";

import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { PromocodeType } from "./Types";

import { Get_Promocode, Delete_Promocode } from "Services/Requests";
// import {  } from "Util/Alerts";
import Styles from "Styles/Styles.module.css";

function PromocodeComp() {
    const Navigate = useNavigate();
    let TableHead = [
        "IMAGE",
        "Promocode",
        "TYPE",
        "OFFER VALUE",
        "MAX DISCOUNT",
        "START DATE",
        "END DATE",
        "STATUS",
        "ACTIONS",
    ];
    const [Promocode, setPromocode] = useState<PromocodeType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const getPromocode = async () => {
        try {
            const response = await Get_Promocode();
            if (response?.data?.status === 1) {
                setPromocode(response?.data?.promocodes);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const DeletePromocode = async (id: any) => {
        setLoading(true);
        try {
            const response = await Delete_Promocode(id);
            if (response?.data?.status === 1) {
                Toast("Promocode Deleted Successfully", "success");
                getPromocode();
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        getPromocode();
    }, []);

    // Function to handle image click and show the modal
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsModalVisible(true);
    };

    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    const deleteHandler = (item: PromocodeType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete Promocode?",
            () => DeletePromocode(item.promoCodeId),
            "Delete"
        );
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="Promocode"
            />
            <header>
                <h3>Promocode</h3>
                <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/promocodes/add")}>
                    <FiPlus />
                    Add Promocode
                </button>
            </header>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {Promocode.length > 0 ? (
                                Promocode?.map((item) => (
                                    <tr key={item?.promoCodeId}>
                                        <td
                                            onClick={() =>
                                                handleImageClick(item.imageUrl)
                                            }>
                                            <div className={Styles["banner"]}>
                                                <img
                                                    src={item.imageUrl}
                                                    alt="Promocode"
                                                />
                                            </div>
                                        </td>{" "}
                                        <td>{item.promoCode}</td>
                                        <td>
                                            {item.type == 1
                                                ? "Percent"
                                                : "Amount"}
                                        </td>
                                        <td>{item.offerValue}</td>
                                        <td>{item.maxDiscount}</td>
                                        <td>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item.startDate}
                                            </Moment>
                                        </td>
                                        <td>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item.endDate}
                                            </Moment>
                                        </td>
                                        <td>
                                            {item.status == 1 ? (
                                                <span
                                                    className={
                                                        Styles["Active"]
                                                    }>
                                                    Active
                                                </span>
                                            ) : (
                                                <span
                                                    className={
                                                        Styles["InActive"]
                                                    }>
                                                    InActive
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/promocodes/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Promocode Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default PromocodeComp;
